import { BalanceType } from '~apis/dashboard';

export const enum AccountType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS',
  Overdraft = 'OVERDRAFT',
  Fx = 'FX',
  Loan = 'LOAN',
  Funds = 'FUNDS',
  Unknown = 'UNKNOWN',
  Error = 'ERROR',
  Securities = 'SECURITIES',
}

export const AccountTypeTextMap: Record<AccountType, string> = {
  [AccountType.Checking]: '입출금',
  [AccountType.Savings]: '예적금',
  [AccountType.Securities]: '증권',
  [AccountType.Funds]: '펀드',
  [AccountType.Loan]: '대출',
  [AccountType.Fx]: '외화',
  [AccountType.Overdraft]: '마이너스',
  [AccountType.Unknown]: '-',
  [AccountType.Error]: '-',
};

export const AccountTypeColorMap: Record<AccountType, string> = {
  [AccountType.Checking]: '#B79776',
  [AccountType.Savings]: '#47C5CE',
  [AccountType.Securities]: '#8C59AF',
  [AccountType.Funds]: '#8C59AF',
  [AccountType.Fx]: '#1A5633',
  [AccountType.Loan]: '#E47B0F',
  [AccountType.Overdraft]: '#79A7E1',
  [AccountType.Unknown]: 'black',
  [AccountType.Error]: 'black',
};

export const BalanceTypeColorMap: Record<BalanceType, string> = {
  [BalanceType.CHECKING_ACCOUNT]: '#B79776',
  [BalanceType.SAVING_ACCOUNT]: '#47C5CE',
  [BalanceType.FUNDS_ACCOUNT]: '#8C59AF',
  [BalanceType.CREDIT_CARD_LIMIT]: '#E47B0F',
  [BalanceType.FX_ACCOUNT]: '#1A5633',
  [BalanceType.OVERDRAFT_LIMIT]: '#79A7E1',
  [BalanceType.SECURITY_ACCOUNT]: '#79A7E1',
};

export function getAccountTypeText(accountType: AccountType) {
  return AccountTypeTextMap[accountType];
}

export const enum BankAccountBalanceStrategy {
  Balance = 'Balance',
  Withdrawable = 'Withdrawable',
}

export const enum CashFlowGroupByStrategy {
  ByAcccount = 'ByAccount',
  ByBusinessEntity = 'ByBusinessEntity',
}
